module.exports = __webpack_public_path__ + "static/media/dice-icon.21edb7cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dice-icon.png
// module id = 295
// module chunks = 0